import { defineStore } from "pinia";
import { useConfigStore } from "@/store/config";

export const useDialogStore = defineStore("dialog", {
  state: () => ({
    warnText: "",
    innerHtml: "",
    action: "",
    options: [],
    onConfirmCallback: null,
    isShowing: false,
    isClosing: false, // 新增: 標記是否正在關閉
    _showModal: null,
    _hideModal: null,
  }),

  getters: {
    isStreamMode: (state) => state.action === "changeStream",
  },

  actions: {
    // 一般 dialog
    showDialog(text, actionType, userStatus = "") {
      // 防止重複調用 (包括正在關閉的狀態)
      if (this.isShowing || this.isClosing) {
        console.warn("Dialog is showing or closing, ignoring new call");
        return false;
      }

      const configStore = useConfigStore();

      this.warnText = text;
      this.innerHtml = "";
      this.action = actionType;
      this.options = [];
      this.onConfirmCallback = null;
      this.isShowing = true;
      this.isClosing = false;

      if (userStatus !== "") {
        configStore.userStatus = userStatus;
      }

      if (this._showModal) {
        this._showModal();
      }

      return true;
    },

    // 選擇 dialog
    showOptionsDialog(actionType, options, onConfirm) {
      // 防止重複調用 (包括正在關閉的狀態)
      if (this.isShowing || this.isClosing) {
        console.warn("Dialog is showing or closing, ignoring new call");
        return false;
      }

      this.warnText = "";
      this.innerHtml = "";
      this.action = actionType;
      this.options = options;
      this.onConfirmCallback = onConfirm;
      this.isShowing = true;
      this.isClosing = false;

      if (this._showModal) {
        this._showModal();
      }

      return true;
    },

    // 隱藏 dialog
    hideDialog() {
      // 如果已經在關閉中,忽略
      if (this.isClosing) {
        console.warn("Dialog is already closing");
        return;
      }

      this.isClosing = true; // 標記為正在關閉

      if (this._hideModal) {
        this._hideModal();
      }

      setTimeout(() => {
        this.warnText = "";
        this.innerHtml = "";
        this.action = "";
        this.options = [];
        this.onConfirmCallback = null;
        this.isShowing = false;
        this.isClosing = false; // 重置關閉狀態
      }, 300);
    },

    // 強制立即關閉 (不等待動畫)
    forceHide() {
      if (this._hideModal) {
        this._hideModal();
      }

      // 立即清空
      this.warnText = "";
      this.innerHtml = "";
      this.action = "";
      this.options = [];
      this.onConfirmCallback = null;
      this.isShowing = false;
      this.isClosing = false;
    },
    // 強制關閉 dialog (用於特殊情況)
    forceHide() {
      if (this._hideModal) {
        this._hideModal();
      }
      this.warnText = "";
      this.innerHtml = "";
      this.action = "";
      this.options = [];
      this.onConfirmCallback = null;
      this.isShowing = false;
    },
  },
});
